import { useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LocomotiveScrollProvider } from 'react-locomotive-scroll';
import Header from "./components/header/Header";
import About from "./pages/About";
import Home from "./pages/Home";
import Location from "./pages/Location";

function App() {   

  const scrollContainer = useRef(null);

  return (
    <>
      <BrowserRouter> 
        <Header/>
        <LocomotiveScrollProvider
                options={{
                    smooth: true, 
                    smartphone: {
                        smooth: true,
                    },
                    tablet: {
                        smooth: true,
                    },
                }}
                containerRef={scrollContainer}
            > 
            <main id="main-container" data-scroll-container ref={scrollContainer}>  
              <Routes> 
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/location" element={<Location/>}/>
              </Routes>   
            </main>
        </LocomotiveScrollProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
